import $msg from './message'
import { get } from '.'

export const requestConfig = {
    debounceInterval: 500, // 防抖
    loadingDelay: 200, // 加载延时，防止闪烁
    onError: (e: any) => {
        get(e, 'data.message', '') && $msg('error', e.data.message)
    },
}
